import { Icon, Tooltip } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { LuInfo } from "react-icons/lu";

export function DeveloperModeIcon() {
  const { developerMode } = useTenant();

  if (!developerMode) return null;

  return (
    <Tooltip hasArrow label="Only visible to developers" placement="right">
      <Icon fontSize="sm">
        <LuInfo size={24} color="secondary" />
      </Icon>
    </Tooltip>
  );
}
